import type { ComponentProps } from "react";
import BaseActionButton from "./BaseActionButton";

type ContinueButtonProps = Omit<
    ComponentProps<typeof BaseActionButton>,
    "iconType" | "testId" | "buttonType" | "label" | "loadingText"
> & {
    label?: string;
    loadingText?: string;
    buttonType?: "submit" | "button";
};

const ContinueButton = ({
    label = "Continue",
    loadingText = "Continuing...",
    buttonType = "button",
    ...props
}: ContinueButtonProps) => {
    return (
        <BaseActionButton
            label={label}
            loadingText={loadingText}
            iconType="continue"
            testId="continue-button"
            buttonType={buttonType}
            {...props}
        />
    );
};

export default ContinueButton;
